<template>
    <el-container
        :class="classObj"
        @click="handleClickOutside"
    >
        <!-- Хедер скрываем в режиме embed -->
        <page-header v-if="!isEmbedded"></page-header>

        <el-container
            class="app-main"
            :class="{ 'app-main--embedded': isEmbedded }"
        >
            <!-- Сайдбар тоже убираем в embed -->
            <sidebar-nav v-if="!isEmbedded"></sidebar-nav>

            <el-main
                class="main-container"
                :class="{ 'main-container--embedded': isEmbedded }"
            >
                <app-main />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { AppMain } from './components';
import SidebarNav from './components/Sidebar';
import PageHeader from './components/Header';
import { mapState } from 'vuex';

export default {
    name: 'Layout',
    components: {
        PageHeader,
        AppMain,
        SidebarNav,
    },
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
            showSettings: state => state.settings.showSettings,
            fixedHeader: state => state.settings.fixedHeader,
        }),

        // Флаг: страница открыта как встроенный виджет
        // 1) ?embed=1 в query
        // 2) или meta.embed = true на маршруте (на будущее)
        isEmbedded() {
            if (this.$route?.query?.embed === '1') {
                return true;
            }
            return !!(this.$route?.meta && this.$route.meta.embed);
        },

        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile',
            };
        },
    },
    methods: {
        handleClickOutside() {
            // В embed-режиме сайдбара нет — ничего не делаем
            if (this.isEmbedded) {
                return;
            }

            this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
        },
    },
};
</script>

<style scoped>
/* Когда страница используется как виджет — убираем отступы от сайдбара/хедера */

.app-main--embedded {
    margin-left: 0 !important;      /* если у app-main есть сдвиг из-за сайдбара */
}

.main-container--embedded {
    padding-top: 0 !important;      /* если есть отступ под хедер */
}
</style>
